import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import { api } from './baseAPI';

const firebaseConfig = {
  apiKey: 'AIzaSyArxruxp6kW8MLidk_1G5etyN5C8zrBBiI',
  authDomain: 'dreamdrums-d2cc5.firebaseapp.com',
  projectId: 'dreamdrums-d2cc5',
  storageBucket: 'dreamdrums-d2cc5.firebasestorage.app',
  messagingSenderId: '87541028184',
  appId: '1:87541028184:web:322dc3da0f9a8e86b0012d',
};

const VAPID_KEY = 'BAQRcsuoRs2MDevuEGL-osEfKSEgMShXd2eR0yhb-SRtZOZ0Vsdix8CDJ0eMHshBB5mVqksvju9yo1ot-0J2q_4';

// Flutter WebView 환경인지 확인
const isFlutterWebView = (): boolean => {
  return !!(window as any).FlutterChannel;
};

// FCM 토큰을 서버에 등록
export const registerDeviceToken = async (
  token: string,
  platform: 'android' | 'ios' | 'web',
  userType: 'user' | 'teacher'
): Promise<void> => {
  try {
    const endpoint = userType === 'teacher'
      ? '/device-tokens/register-teacher'
      : '/device-tokens/register';

    console.log(`[PUSH-DEBUG] React: 서버에 토큰 등록 요청 (endpoint=${endpoint}, platform=${platform}, token=${token.substring(0, 20)}...)`);
    const res = await api.post(endpoint, { token, platform });
    console.log('[PUSH-DEBUG] React: 서버 응답:', res.data);
  } catch (err: any) {
    console.error('[PUSH-DEBUG] React: 서버 토큰 등록 실패:', err.response?.status, err.response?.data || err.message);
  }
};

// FCM 토큰 비활성화 (로그아웃 시)
export const unregisterDeviceToken = async (
  token: string,
  userType: 'user' | 'teacher'
): Promise<void> => {
  try {
    const endpoint = userType === 'teacher'
      ? '/device-tokens/unregister-teacher'
      : '/device-tokens/unregister';

    await api.post(endpoint, { token });
  } catch (err) {
    console.error('디바이스 토큰 비활성화 실패:', err);
  }
};

// 저장된 FCM 토큰 가져오기
let currentFcmToken: string | null = null;
let currentPlatform: 'android' | 'ios' | 'web' = 'web';

export const getCurrentFcmToken = () => currentFcmToken;
export const getCurrentPlatform = () => currentPlatform;

// Flutter에서 FCM 토큰을 수신하는 글로벌 함수
(window as any).receiveFcmToken = (token: string, platform: string) => {
  currentFcmToken = token;
  currentPlatform = platform as 'android' | 'ios' | 'web';
  console.log(`[PUSH-DEBUG] React: Flutter에서 토큰 수신 (platform=${platform}, token=${token.substring(0, 20)}...)`);

  // 저장된 사용자 정보가 있으면 바로 등록
  const pendingUserType = sessionStorage.getItem('pendingFcmUserType');
  console.log(`[PUSH-DEBUG] React: pendingFcmUserType = ${pendingUserType}`);
  if (pendingUserType) {
    console.log(`[PUSH-DEBUG] React: pending 있음 → 서버 등록 시도`);
    registerDeviceToken(token, currentPlatform, pendingUserType as 'user' | 'teacher');
    sessionStorage.removeItem('pendingFcmUserType');
  } else {
    console.log('[PUSH-DEBUG] React: pending 없음 → 토큰만 저장 (로그인 시 등록됨)');
  }
};

// Flutter에서 라우팅을 요청하는 글로벌 함수 (App.tsx의 NavigateHelper에서 재정의됨)
(window as any).navigateFromFlutter = (window as any).navigateFromFlutter || ((route: string) => {
  window.location.href = route;
});

// 웹 브라우저에서 FCM 초기화 (Flutter WebView가 아닌 경우)
export const initWebPush = async (userType: 'user' | 'teacher'): Promise<void> => {
  console.log(`[PUSH-DEBUG] React: initWebPush 호출 (userType=${userType}, isFlutterWebView=${isFlutterWebView()}, currentFcmToken=${currentFcmToken ? currentFcmToken.substring(0, 20) + '...' : 'null'})`);

  // Flutter에서 이미 토큰을 받은 경우 (앱 환경)
  if (currentFcmToken && currentPlatform !== 'web') {
    console.log('[PUSH-DEBUG] React: 앱 토큰 있음 → 서버 등록');
    await registerDeviceToken(currentFcmToken, currentPlatform, userType);
    return;
  }

  if (isFlutterWebView() || currentFcmToken) {
    if (currentFcmToken) {
      console.log('[PUSH-DEBUG] React: Flutter WebView + 토큰 있음 → 서버 등록');
      await registerDeviceToken(currentFcmToken, currentPlatform, userType);
    } else {
      console.log('[PUSH-DEBUG] React: Flutter WebView + 토큰 없음 → pending 저장 & Flutter에 토큰 요청');
      sessionStorage.setItem('pendingFcmUserType', userType);
      try {
        (window as any).FlutterChannel?.postMessage(
          JSON.stringify({ type: 'requestFcmToken' })
        );
      } catch (e) {
        console.error('[PUSH-DEBUG] React: Flutter FCM 토큰 요청 실패:', e);
      }
    }
    return;
  }

  // 웹 브라우저: Firebase 웹 SDK 사용
  try {
    console.log('[Push] 웹 푸시 초기화 시작');

    if (!('Notification' in window) || !('serviceWorker' in navigator)) {
      console.log('[Push] 브라우저가 푸시를 지원하지 않습니다.');
      return;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('[Push] 알림 권한이 거부되었습니다.');
      return;
    }

    // Firebase 초기화 (서비스 워커 등록은 Firebase가 자동 관리)
    console.log('[Push] Firebase 초기화 중...');
    const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
    const messaging = getMessaging(app);

    console.log('[Push] FCM 토큰 요청 중...');
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });

    if (token) {
      currentFcmToken = token;
      currentPlatform = 'web';
      await registerDeviceToken(token, 'web', userType);
      console.log('[Push] 웹 푸시 토큰 등록 완료');
    } else {
      console.log('[Push] FCM 토큰을 받지 못했습니다.');
    }
  } catch (err: any) {
    console.error('[Push] 웹 푸시 초기화 실패:', err.name, err.message);

    // PushManager 직접 테스트 (진단용)
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: VAPID_KEY,
      });
      console.log('[Push] 직접 구독 성공:', sub.endpoint);
    } catch (subErr: any) {
      console.error('[Push] PushManager 직접 구독도 실패:', subErr.name, subErr.message);
    }
  }
};

// 로그아웃 시 토큰 정리
export const cleanupPushToken = async (userType: 'user' | 'teacher'): Promise<void> => {
  if (currentFcmToken) {
    await unregisterDeviceToken(currentFcmToken, userType);
  }
};
